export const HOME_SLIDER_TAG = {
  DEFAULT: "HOME_SLIDER",
  SUSTAINABILITY_REPORTS: "SUSTAINABILITY_REPORTS",
};
